export enum EnumBufferTypes {
    Default = 1,
    Valet_Parking = 2,
}